import React from "react";
import {Container as BootStrapContainer} from "react-bootstrap";

type Props = {
  children: React.ReactNode;

  id?: string;
  fluid?: boolean;
  className?: string;
};

const Container = (props: Props) => {
  return (
    <BootStrapContainer id={props.id} className={props.className} fluid={props.fluid}>
      {props.children}
    </BootStrapContainer>
  );
};

export default Container;
